import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { SearchCommandInput } from "~/components/SearchCommand/SearchCommandInput";
import { SmartSearchCommandInput } from "~/components/SearchCommand/SmartSearchCommandInput";
export const SearchCommandInputBase = /*#__PURE__*/ memo((param)=>{
    let { count, onValueChange, placeholder, value, canUseSmartSearch } = param;
    const InputComponent = canUseSmartSearch ? SmartSearchCommandInput : SearchCommandInput;
    return /*#__PURE__*/ _jsx(InputComponent, {
        count: count,
        onValueChange: onValueChange,
        placeholder: placeholder,
        value: value
    });
});
SearchCommandInputBase.displayName = "SearchCommandInputBase";
